<mat-card class="history-card">
  <!-- Header (same structure as referral-history) -->
  <div class="header">
    <div class="row row-top">
      <div class="title-wrap">
        <mat-icon>history</mat-icon>
        <h2 class="title">Member Referrals</h2>
        <span class="sub" *ngIf="memberId">· Member {{ memberId }}</span>
      </div>

      <div class="title-actions">
        <button mat-icon-button matTooltip="Refresh" (click)="load()" aria-label="Refresh member referrals">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>

    <div class="row row-actions">
      <mat-form-field appearance="outline" class="search">
        <mat-label>Search referrals</mat-label>
        <input matInput placeholder="DCO, source, status…" [value]="query"
               (input)="onQuery(($any($event.target)).value)" />
        <button *ngIf="query" matSuffix mat-icon-button aria-label="Clear" (click)="onQuery('')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-button-toggle-group [value]="sourceFilter" (change)="setSourceFilter($event)">
        <mat-button-toggle value="ALL">All</mat-button-toggle>
        <mat-button-toggle value="PCP">PCP</mat-button-toggle>
        <mat-button-toggle value="HRAT">HRAT</mat-button-toggle>
        <mat-button-toggle value="Maternity">Maternity</mat-button-toggle>
      </mat-button-toggle-group>

      <button mat-stroked-button class="nowrap" (click)="toggleReprocess()">
        <i class="fa-sharp-duotone" [ngClass]="{'fa-eye': includeReprocess, 'fa-eye-slash': !includeReprocess}"></i>
        {{ includeReprocess ? 'Show: All (incl. Reprocess)' : 'Hide Reprocess' }}
      </button>

      <span class="spacer"></span>
    </div>
  </div>

  <mat-card-content>
    <div class="table-wrap" *ngIf="total > 0; else emptyTpl">
      <table mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDirection="desc" matSortDisableClear>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [start]="'desc'">Submitted / Imported Date</th>
          <td mat-cell *matCellDef="let r" [class.recent]="r.isRecent">
            {{ r.createdUtc | date:'MMM d, y, h:mm a' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="source">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="!r.isHidden; else masked"> {{ r.sourceType }} </ng-container>
            <ng-template #masked> — </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="dco">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>DCO</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="!r.isHidden; else hiddenMsg">
              {{ r.dcoName || '—' }}
            </ng-container>
            <ng-template #hiddenMsg>
              <span class="hipaa-note">Belongs to another DCO</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="!r.isHidden; else statusMasked">
              <mat-chip-set>
                <mat-chip *ngIf="r.isClosed" color="primary" selected>Closed</mat-chip>
                <mat-chip *ngIf="!r.isClosed">Open</mat-chip>
                <mat-chip *ngIf="r.isUrgent" color="warn" selected>Urgent</mat-chip>
                <mat-chip *ngIf="r.isInReprocess" color="accent" selected>Reprocess</mat-chip>
              </mat-chip-set>
            </ng-container>
            <ng-template #statusMasked> — </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let r">
            <button mat-icon-button
                    (click)="openReferralStatusDialog(r)"
                    [disabled]="r.isHidden"
                    [matTooltip]="r.isHidden ? 'Hidden: belongs to another DCO' : 'Edit' "
                    aria-label="Edit referral"
                    [attr.aria-disabled]="r.isHidden">
              <i class="fa-sharp-duotone fa-solid fa-pencil"></i>
            </button>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <ng-template #emptyTpl>
      <div class="empty">
        <mat-icon>info</mat-icon>
        No referral history found for this member.
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
